import React, { useEffect, useState } from "react";
import './AboutNew11.css';
import { Link } from 'react-router-dom';
import axios from "axios";

function AboutNew() {
  const [About, setAbout] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_about_us_list"
      );
      setAbout(response.data.data);
    };

    fetchData();
  }, []);

  // Limit HTML content by characters
  const limitHTML = (html, limit) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.innerText;

    if (text.length <= limit) return html;

    const trimmed = text.substring(0, limit) + "...";
    return trimmed;
  };


  return (
    <>
      <section className="about-section about-top">
        {About.filter((Data) => Data.about_id === "4").map((Data, index) => (
          <div className="container" key={index}>
            <div className="row">

              <div className="col-lg-6 col-md-12 order-lg-1 order-2">
                <div className="about_wrapper">
                  <figure className="mb-0 about-image1">
                    <img src={`https://cyberathon.com/NLF/${Data.img_1}`} alt="" />
                  </figure>

                  <figure className="mb-0 about-image2">
                    <img
                      src={`https://cyberathon.com/NLF/${Data.img_2}`}
                      alt=""
                      className="aboutimg22 img-fluid"
                    />
                  </figure>

                  <figure className="mb-0 about-dot">
                    <img src="about-img/about-us-dot.png" alt="" className="img-fluid" />
                  </figure>

                  <figure className="mb-0 about-leftcircle">
                    <img src="about-img/about-us-leftcircle.png" alt="" className="img-fluid" />
                  </figure>

                  <figure className="mb-0 about-layer">
                    <img src="about-img/about-us-layer.png" alt="" className="img-fluid" />
                  </figure>
                </div>
              </div>

              <div className="col-lg-6 col-md-12 order-lg-2 order-1">
                <div className="about_content aos-init" data-aos="fade-right" data-aos-delay={100}>
                  <h3><strong>{Data.abt_title}</strong></h3>

                  <h2 className="text-white">
                    We offer an exclusive design gallery featuring leading manufacturers
                  </h2>

                  <p dangerouslySetInnerHTML={{ __html: limitHTML(Data.abt_description, 850) }}></p>


                  <Link to="/about-us" className="read_more text-white text-decoration-none">
                    Read More
                    <figure className="mb-0">
                      <img src="about-img/button-arrow.png" alt="" className="img-fluid" />
                    </figure>
                  </Link>
                </div>
              </div>

            </div>
          </div>
        ))}
      </section>
    </>
  );
}

export default AboutNew;
